// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeOffHolidays_wrapper__qSPYX","controls":"TimeOffHolidays_controls__gjDKM","searchWrapper":"TimeOffHolidays_searchWrapper__X0Hfo"};